import { Navigate, useLocation } from "react-router-dom";
import useUser from "@/integration/user/hooks/useUser";

interface PrivateRouteProps {
  children: React.ReactNode;
}

export default function PrivateRoute({ children }: PrivateRouteProps) {
  const { userAuth, isLoadingAuth } = useUser();
  const location = useLocation();

  // Carregando o contexto? Espera.
  if (isLoadingAuth) {
    return null; // Ou um componente de loading
  }

  // Usuário não está logado? Redireciona.
  if (!userAuth) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
